/** The sign-in provider buttons (Telegram, Google): white, bordered, 44px, the logo in its own colours. */
export const socialButtonClassName =
  'inline-flex h-11 w-full items-center justify-center gap-[9px] rounded-[10px] border border-border bg-card text-sm font-semibold text-foreground ' +
  'transition-colors hover:border-foreground/20 hover:bg-muted/50 disabled:opacity-60 ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';
